import { render, staticRenderFns } from "./Qiu360ForResult.vue?vue&type=template&id=20c2bb8c&scoped=true"
import script from "./Qiu360ForResult.vue?vue&type=script&lang=js"
export * from "./Qiu360ForResult.vue?vue&type=script&lang=js"
import style0 from "./Qiu360ForResult.vue?vue&type=style&index=0&id=20c2bb8c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c2bb8c",
  null
  
)

export default component.exports